var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallPlayOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9787 5.86719L6.99202 2.41386C6.64183 2.17182 6.2321 2.03019 5.80719 2.00431C5.38228 1.97844 4.9584 2.06931 4.58142 2.26707C4.20445 2.46483 3.88874 2.76194 3.66852 3.12624C3.44829 3.49055 3.33194 3.90817 3.33203 4.33386V11.2405C3.33194 11.6662 3.44829 12.0838 3.66852 12.4481C3.88874 12.8124 4.20445 13.1096 4.58142 13.3073C4.9584 13.5051 5.38228 13.5959 5.80719 13.5701C6.2321 13.5442 6.64183 13.4026 6.99202 13.1605L11.9787 9.7072C12.2895 9.49259 12.5435 9.20575 12.719 8.87132C12.8944 8.53689 12.9861 8.16486 12.9861 7.78719C12.9861 7.40952 12.8944 7.03749 12.719 6.70307C12.5435 6.36864 12.2895 6.0818 11.9787 5.86719V5.86719Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPlayOrange);
export default __webpack_public_path__ + "static/media/small-play-orange.3975b3f387fa05cee7a944330a7144d2.svg";
export { ForwardRef as ReactComponent };